<template>
  <!-- Recipient journey Part 7, Stage 4: the Mystic's closing turn after You &
       <sender> (R7.3). The people she named in her own words this session are
       links in the turn ("You mentioned your mom. Want to sit with what's
       between you two?"), and "Someone else" opens the Respond box.
       Integration: <StageFour :turn @pick @someone-else /> in the chat
       (ChatContainerReader), started by the room (ReaderPage). -->
  <div class="s4" data-testid="stage-four">
    <div class="s4-turn">
      <p class="s4-text" data-testid="s4-line">{{ turn.line }}</p>
      <p class="s4-links">
        <template v-for="(l, i) in links" :key="i">
          <span v-if="i" class="s4-sep" aria-hidden="true">·</span>
          <button type="button" class="s4-link"
                  :data-testid="l.someoneElse ? 's4-someone-else' : 's4-person'"
                  :disabled="picked" @click="choose(l)">{{ l.label }}</button>
        </template>
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { track } from '@/utils/analytics'
import { peopleLinks } from '@/utils/stage-four'

const props = defineProps({
  // { line, people: [{ label, for_name, name, role }], someone_else }
  turn: { type: Object, required: true },
})
const emit = defineEmits(['pick', 'someone-else'])

const links = computed(() => peopleLinks(props.turn))
const picked = ref(false)

function choose(link) {
  if (picked.value) return
  if (link.someoneElse) {
    track('gift_person', { via: 'someone_else' })
    emit('someone-else')
    return
  }
  picked.value = true
  track('gift_person', { via: 'named' })
  emit('pick', link.person)
}
</script>

<style scoped>
.s4 { margin: 14px 0; }
.s4-turn { position: relative; max-width: 88%; padding: 1px 0 1px 20px; }
.s4-turn::before { content: ''; position: absolute; left: 0; top: 4px; bottom: 4px; width: 2px; border-radius: 2px;
  background: linear-gradient(180deg, var(--cr-gold, #f0d9a3) 0%, var(--cr-gold-soft, rgba(240,217,163,0.4)) 38%, rgba(240, 217, 163, 0.05) 100%); }
.s4-text { margin: 0; color: var(--cr-ink, #efe6ff); font-family: var(--cr-serif, Georgia, serif); font-size: 19px; line-height: 1.62; }
.s4-links { margin: 8px 0 0; display: flex; flex-wrap: wrap; align-items: center; gap: 4px 10px; }
.s4-sep { color: var(--cr-gold-soft, rgba(240,217,163,0.5)); }
.s4-link { background: none; border: none; padding: 6px 0; min-height: 36px; font: inherit; font-family: var(--cr-serif, Georgia, serif);
  font-size: 18px; color: var(--cr-gold, #f0d9a3); text-decoration: underline; text-underline-offset: 4px; cursor: pointer; }
.s4-link:disabled { opacity: 0.6; cursor: default; }
@media (max-width: 699px) {
  .s4-text { font-size: 17px; }
  .s4-link { font-size: 17px; }
  .s4-turn { max-width: 100%; padding-left: 15px; }
}
</style>
